module.exports = __webpack_public_path__ + "media/images/etyekilogo-apple-76x76-cba50c110cf99341216693802340a669.png";